"use client";

import { motion } from "framer-motion";

const steps = [
  {
    title: "Discovery",
    desc: "We analyze your system, goals, and operational requirements to define the right direction.",
  },
  {
    title: "Strategy",
    desc: "We design a structured execution plan focused on efficiency, performance, and scalability.",
  },
  {
    title: "Execution",
    desc: "Our team builds and implements solutions with precision engineering standards.",
  },
  {
    title: "Optimization",
    desc: "We refine performance continuously for long-term reliability and maximum output.",
  },
];

export default function ProcessSection() {
  return (
    <section className="relative py-24 bg-white overflow-hidden">

      {/* Background Layer */}
      <div className="absolute inset-0">
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[600px] h-[600px] bg-blue-100/50 blur-3xl rounded-full" />
      </div>

      <div className="max-w-6xl mx-auto px-6 relative z-10">

        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="text-center mb-20"
        >
          <h2 className="text-4xl md:text-5xl font-bold text-blue-600">
            Our Working Process
          </h2>
          <p className="text-gray-500 mt-4 text-lg">
            Structured execution from idea to industrial-grade delivery
          </p>
        </motion.div>

        {/* Timeline Container */}
        <div className="relative">

          {/* Center line (desktop) */}
          <div className="hidden md:block absolute left-1/2 top-0 bottom-0 w-[2px] bg-blue-100" />

          <div className="space-y-16 md:space-y-24">

            {steps.map((step, i) => {
              const isLeft = i % 2 === 0;

              return (
                <div
                  key={i}
                  className={`relative flex flex-col md:flex-row items-center ${
                    isLeft ? "md:justify-start" : "md:justify-end"
                  }`}
                >

                  {/* Content Box */}
                  <motion.div
                    initial={{ opacity: 0, x: isLeft ? -50 : 50 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    transition={{ duration: 0.6, delay: i * 0.1 }}
                    className="md:w-5/12 bg-white border border-gray-100 rounded-2xl p-8 shadow-sm hover:shadow-xl transition"
                  >
                    <div className="flex items-center gap-4 mb-4">
                      <div className="w-10 h-10 rounded-full bg-blue-600 text-white flex items-center justify-center font-bold">
                        {i + 1}
                      </div>
                      <h3 className="text-xl font-semibold text-gray-900">
                        {step.title}
                      </h3>
                    </div>

                    <p className="text-gray-500 leading-relaxed">
                      {step.desc}
                    </p>
                  </motion.div>

                  {/* Center Dot */}
                  <div className="hidden md:flex absolute left-1/2 -translate-x-1/2 w-4 h-4 bg-blue-600 rounded-full shadow-md" />
                </div>
              );
            })}

          </div>
        </div>
      </div>
    </section>
  );
}